import { createFileRoute } from '@tanstack/react-router'
import { ProgressNoteTemplatesSettings } from '@/features/organizations/settings/progress-note-templates'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/progress-note-templates/'
)({
  component: ProgressNoteTemplatesSettings,
})
